// Generated from Swagger on 2025-12-04T17:43:47.153Z

// Creation entities query keys - shared across all resources
export const creationEntitiesKeys = {
  all: ["creation-entities"] as const,
  list: () => [...creationEntitiesKeys.all, "list"] as const,
};
